import { render, staticRenderFns } from "./HeaderInformationNavigationEdunet.vue?vue&type=template&id=51ad2340&scoped=true"
import script from "./HeaderInformationNavigationEdunet.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationEdunet.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationEdunet.vue?vue&type=style&index=0&id=51ad2340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad2340",
  null
  
)

export default component.exports